import React, { useState, useEffect } from "react";
import { EventService, TicketService } from "../../../services";
import { Link, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import { Form } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { Table } from "react-bootstrap";
import { injectModels } from "../../../redux/injectModels";
import {
  formatAmount,
  formatDateENGB,
  handleConsoleError,
} from "../../../utils/common-methods";
import { CommonModal } from "../../../shared/commonModal";
import { toast } from "react-toastify";

//import _ from "lodash";

const TicketList = (props) => {
  const { eventId } = useParams();
  const [currentPage, setCurrentPage] = useState(0);
  const [ticketInsight, setTicketInsight] = useState({
    remainingTickets: 0,
    soldTickets: 0,
    totalEarning: 0,
  });
  const [filteredData, setFilteredData] = useState([]);
  const [isModalOpen, setModalOpen] = useState(false);
  const [isModalViewOpen, setViewModalOpen] = useState(false);

  const [refundTicket, setRefundTicket] = useState({
    refundAmount: null,
    ticketId: null,
    refundDescription: "",
    isRefund: false,
  });
  // const navigate = useNavigate();

  const rowsPerPage = 10; // Number of rows to display per page
  const offset = currentPage * rowsPerPage; // Calculate the offset based on current page
  const paginatedData = filteredData.slice(offset, offset + rowsPerPage);

  const {
    register,
    handleSubmit,
    setError,
    clearErrors,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    getTicketsData();
  }, []);

  const getTicketsData = async () => {
    try {
      props.application.setLoading(true);
      if (eventId) {
        const res = await TicketService.getTicketInsights(eventId);
        if (res?.isSuccess && res?.data) {
          setTicketInsight({
            totalEarning: res?.data?.totalEarning,
            soldTickets: res?.data?.soldTickets,
            remainingTickets: res?.data?.remainingTickets,
          });
          setFilteredData(res?.data?.objEventTicketBuyTicketModel ?? []);
        }
      }
      props.application.setLoading(false);
    } catch (error) {
      props.application.setLoading(false);
      const message=handleConsoleError(error);
      toast.error(error?.message|| message);
    }
  };

  const handleEdit = async (item) => {
    try {
      setRefundTicket(item);
      setModalOpen(true);
    } catch (error) {}
  };
  const handleView = async (item) => {
    try {
      setRefundTicket(item);
      setViewModalOpen(true);
    } catch (error) {}
  };

  const closeModal = () => {
    setModalOpen(false);
    setRefundTicket({
      refundAmount: null,
      ticketId: null,
      refundDescription: "",
      isRefund: false,
    });
    clearErrors("refundAmount");
    clearErrors("refundDescription");
    reset();
  };
  const closeViewModal = () => {
    setViewModalOpen(false);
  };

  const calculateSNo = (index) => {
    return offset + index + 1;
  };

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
  };

  const renderPagination = () => {
    const pageCount = Math.ceil(filteredData.length / rowsPerPage);
    if (pageCount > 1) {
      return (
        <ReactPaginate
          previousLabel="previous"
          nextLabel="next"
          breakClassName={"page-item"}
          breakLinkClassName={"page-link"}
          containerClassName={"pagination"}
          pageClassName={"page-item"}
          pageLinkClassName={"page-link"}
          previousClassName={"page-item"}
          previousLinkClassName={"page-link"}
          nextClassName={"page-item"}
          nextLinkClassName={"page-link"}
          activeClassName={"active"}
          pageCount={pageCount}
          pageRangeDisplayed={2}
          marginPagesDisplayed={1}
          onPageChange={handlePageChange}
          forcePage={currentPage}
          breakLabel="..."
          disableInitialCallback={false}
        />
      );
    }
    return null;
  };

  // const handleCreatePitch = async (e) => {
  //   EventService.removePitchId(); //change
  //   navigate(routes.ACCOUNT_CREATE_PITCH);
  // };

  const getTicketStatusString = (status) => {
    switch (status) {
      case 1:
        return "Redeemed";
      case 2:
        return "Active";
      case 3:
        return "Cancel";
      default:
        return "";
    }
  };

  const cardStyleComponent = (data) => {
    return (
      <div class="col-md-4 col-sm-12 tkt-box">
        <div class="row">
          <div
            style={{ display: "flex", alignItems: "center" }}
            class="col-md-3 col-sm-12"
          >
            <div
              style={{
                minWidth: "50px",
                minHeight: "50px",
                border: "3px solid rgb(236, 46, 122)",
                borderRadius: "25px",
                textAlign: "center",
                display: "flex",
                width: "50px",
                height: "50px",
              }}
            >
              <i
                style={{
                  fontSize: "25px",
                  margin: "auto",
                  color: "rgb(236, 46, 122)",
                }}
                class="fa-solid fa-ticket"
              ></i>
            </div>
          </div>
          <div
            style={{
              textAlign: "left",
              display: "flex",
              alignItems: "flex-start",
              flexDirection: "column",
            }}
            class="col-md-9 col-sm-12"
          >
            <h4>{data?.title}</h4>
            <h1 style={{ fontWeight: "600", fontSize: "40px" }}>
              {data?.value}
            </h1>
          </div>
        </div>
      </div>
      // <div
      //   style={{
      //     flex: 1,
      //     textAlign: "center",
      //     borderRadius: 5,
      //     height: 150,
      //     marginTop: 10,
      //     boxShadow:
      //       "0 4px 8px 0 rgba(0, 0, 0, 0.1), 0 6px 20px 0 rgba(0, 0, 0, 0.1)",
      //     padding: 20,
      //   }}
      //   className="col-md-4 col-sm-12"
      // >
      //   <div
      //     style={{
      //       display: "flex",
      //       alignItems: "center",
      //       columnGap: 10,
      //       marginTop: 10,
      //     }}
      //     className="col-md-4 col-sm-12"
      //   >
      //     <div
      //       style={{
      //         minWidth: 50,
      //         minHeight: 50,
      //         border: "3px solid #ec2e7a",
      //         borderRadius: 25,
      //         textAlign: "center",
      //         display: "flex",
      //       }}
      //       className="col-md-4 col-sm-12"
      //     >
      //       <i
      //         style={{ fontSize: 25, margin: "auto", color: "#ec2e7a" }}
      //         className={data.icon}
      //       ></i>
      //     </div>
      //     <h4>{data.title}</h4>
      //   </div>
      //   <div style={{ textAlign: "left", marginLeft: 60 }}>
      //     <h1 style={{ fontWeight: 600, fontSize: 40 }}>{data.value}</h1>
      //   </div>
      // </div>
    );
  };

  const onSubmit = async (data) => {
    try {
      if (
        data?.refundAmount &&
        data?.refundAmount >
          refundTicket?.price + refundTicket?.processFee + refundTicket?.adminFee
      ) {
        setError("refundAmount", {
          message:
            "Refund amount must be less than or equal to the total amount of " +
            (refundTicket?.price +
              refundTicket?.processFee +
              refundTicket?.adminFee),
        });
        return;
      } else {
        clearErrors("refundAmount");
      }
      const response = await TicketService.refundTicket(data);
      if (response?.isSuccess) {
        getTicketsData();
        reset();
        setModalOpen(false);
        toast.success(response?.message);
      } else {
        toast.error(response?.message);
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  return (
    <React.Fragment>
      <section className="edit-form-table">
        <div className="container">
          {/* <div class="row fl-wrap">
            <div class="col-md-4 col-sm-12 tkt-box">
              <div class="row">
                <div
                  style={{ display: "flex", alignItems: "center" }}
                  class="col-md-3 col-sm-12"
                >
                  <div
                    style={{
                      minWidth: "50px",
                      minHeight: "50px",
                      border: "3px solid rgb(236, 46, 122)",
                      borderRadius: "25px",
                      textAlign: "center",
                      display: "flex",
                      width: "50px",
                      height: "50px",
                    }}
                  >
                    <i
                      style={{
                        fontSize: "25px",
                        margin: "auto",
                        color: "rgb(236, 46, 122)",
                      }}
                      class="fa-solid fa-ticket"
                    ></i>
                  </div>
                </div>
                <div
                  style={{
                    textAlign: "left",
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                  class="col-md-9 col-sm-12"
                >
                  <h4>Active Tickets</h4>
                  <h1 style={{ fontWeight: "600", fontSize: "40px" }}>9</h1>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-12 tkt-box">
              <div class="row">
                <div
                  style={{ display: "flex", alignItems: "center" }}
                  class="col-md-3 col-sm-12"
                >
                  <div
                    style={{
                      minWidth: "50px",
                      minHeight: "50px",
                      border: "3px solid rgb(236, 46, 122)",
                      borderRadius: "25px",
                      textAlign: "center",
                      display: "flex",
                      width: "50px",
                      height: "50px",
                    }}
                  >
                    <i
                      style={{
                        fontSize: "25px",
                        margin: "auto",
                        color: "rgb(236, 46, 122)",
                      }}
                      class="fa-solid fa-ticket"
                    ></i>
                  </div>
                </div>
                <div
                  style={{
                    textAlign: "left",
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                  class="col-md-9 col-sm-12"
                >
                  <h4>Active Tickets</h4>
                  <h1 style={{ fontWeight: "600", fontSize: "40px" }}>9</h1>
                </div>
              </div>
            </div>
            <div class="col-md-4 col-sm-12 tkt-box">
              <div class="row">
                <div
                  style={{ display: "flex", alignItems: "center" }}
                  class="col-md-3 col-sm-12"
                >
                  <div
                    style={{
                      minWidth: "50px",
                      minHeight: "50px",
                      border: "3px solid rgb(236, 46, 122)",
                      borderRadius: "25px",
                      textAlign: "center",
                      display: "flex",
                      width: "50px",
                      height: "50px",
                    }}
                  >
                    <i
                      style={{
                        fontSize: "25px",
                        margin: "auto",
                        color: "rgb(236, 46, 122)",
                      }}
                      class="fa-solid fa-ticket"
                    ></i>
                  </div>
                </div>
                <div
                  style={{
                    textAlign: "left",
                    display: "flex",
                    alignItems: "flex-start",
                    flexDirection: "column",
                  }}
                  class="col-md-9 col-sm-12"
                >
                  <h4>Active Tickets</h4>
                  <h1 style={{ fontWeight: "600", fontSize: "40px" }}>9</h1>
                </div>
              </div>
            </div>
          </div> */}

          <div className="row fl-wrap">
            {cardStyleComponent({
              title: "Tickets Sold",
              value: `${ticketInsight?.soldTickets}`,
              icon: "fa-solid fa-ticket",
            })}
            {cardStyleComponent({
              title: "Tickets Unsold",
              value: `${ticketInsight?.remainingTickets}`,
              icon: "fa-solid fa-ticket-simple",
            })}
            {cardStyleComponent({
              title: "Total Earnings",
              value: `£${formatAmount(ticketInsight?.totalEarning)}`,
              icon: "fa-solid fa-sack-dollar",
            })}
          </div>
          <div style={{ marginTop: 30 }}>
            <h4>Purchased Tickets</h4>
          </div>
          <div className="table-responsive">
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Buyer</th>
                  <th>Amount (£)</th>
                  {/* <th>Process Fee (£)</th> */}
                  <th>Ticket Admin Fee (£)</th>
                  <th>Quantity</th>
                  <th>Purchase Date</th>
                  <th>Order</th>
                  <th>Status</th>
                  <th>Refund</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {paginatedData && paginatedData.length > 0 ? (
                  <React.Fragment>
                    {paginatedData.map((item, idx) => {
                      return (
                        <tr key={idx}>
                          <td>{calculateSNo(idx)}</td>
                          <td>
                            <h5 style={{ marginBottom: 0 }}>
                              {item?.user?.userName}
                            </h5>
                            <h5>{item?.user?.email}</h5>
                          </td>
                          <td>£{formatAmount(item?.price + item?.processFee)}</td>
                          {/* <td>£{formatAmount(item.processFee)}</td> */}
                          <td>£{formatAmount(item?.adminFee)}</td>
                          <td>{item?.qty}</td>
                          <td>{formatDateENGB(item?.purchaseDate)}</td>
                          <td>{item?.id}</td>
                          <td>{getTicketStatusString(item?.ticketStatus)}</td>
                          <td>
                            {item?.isRefund
                              ? `£${formatAmount(item?.refundAmount)}`
                              : ""}
                          </td>
                          <td>
                            <div className="delete-create">
                              {!item?.isRefund && (
                                <Link
                                  title="Refund"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleEdit(item);
                                  }}
                                  style={{ marginRight: "10px" }}
                                >
                                  <i className="ri-pencil-line"></i>
                                </Link>
                              )}
                              {item?.isRefund && (
                                <Link
                                  title="View"
                                  onClick={(e) => {
                                    e.preventDefault();
                                    handleView(item);
                                  }}
                                  style={{ marginRight: "10px" }}
                                >
                                  <i className="fa fa-eye"></i>
                                </Link>
                              )}
                            </div>
                          </td>
                        </tr>
                      );
                    })}
                  </React.Fragment>
                ) : (
                  <tr>
                    <td colSpan="10 mt-2">No results found</td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="table-footer">
            <p className="mb-3">
              <strong>Total Count: {filteredData.length}</strong>
            </p>
            {filteredData.length === 0 ? "" : renderPagination()}
          </div>
        </div>
      </section>
      <React.Fragment>
        <CommonModal
          show={isModalOpen}
          size="md"
          onHide={closeModal}
          title={"Ticket Refund"}
          footerActions={[
            { label: "Close", variant: "secondary", onClick: closeModal },
            {
              label: "Update",
              type: "button",
              onClick: handleSubmit(onSubmit),
            },
          ]}
        >
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group controlId="Id">
              <Form.Control
                type="hidden"
                {...register("id")}
                defaultValue={refundTicket.id}
              />
            </Form.Group>
            <Form.Group controlId="refundAmount">
              <Form.Label>
                Refund Amount(£) <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                maxLength={100}
                type="text"
                {...register("refundAmount", {
                  required: "Refund amount is required",
                  pattern: {
                    value: /^[+]?[0-9]*\.?[0-9]+$/,
                    message: "Please enter a valid number greater than zero.",
                  },
                })}
                defaultValue={refundTicket?.refundAmount}
              />
              {errors.refundAmount && (
                <span className="text-danger">
                  {errors.refundAmount?.message}
                </span>
              )}
            </Form.Group>
            <Form.Group controlId="refundDescription">
              <Form.Label>
                Refund Description <span className="text-danger">*</span>
              </Form.Label>
              <Form.Control
                maxLength={200}
                as="textarea"
                {...register("refundDescription", {
                  required: "Refund description is required",
                })}
                defaultValue={refundTicket?.refundDescription}
              />
              {errors.refundDescription && (
                <span className="text-danger">
                  {errors.refundDescription?.message}
                </span>
              )}
            </Form.Group>
          </Form>
        </CommonModal>
      </React.Fragment>

      <React.Fragment>
        <CommonModal
          show={isModalViewOpen}
          size="md"
          onHide={closeViewModal}
          title={"Ticket Refund Details"}
          footerActions={[{ label: "Close", onClick: closeViewModal }]}
        >
          <Form onSubmit={handleSubmit(onSubmit)}>
            <Form.Group controlId="Id">
              <Form.Control
                type="hidden"
                {...register("id")}
                defaultValue={refundTicket?.id}
              />
            </Form.Group>
            <Form.Group controlId="refundAmount">
              <Form.Label>Refund Amount(£)</Form.Label>
              <Form.Control
                value={"£" + formatAmount(refundTicket?.refundAmount)}
              />
            </Form.Group>
            <Form.Group controlId="refundDescription">
              <Form.Label>Refund Description</Form.Label>
              <Form.Control
                as="textarea"
                value={refundTicket?.refundDescription}
              />
            </Form.Group>
            <Form.Group controlId="refundDate">
              <Form.Label>Refund Date</Form.Label>
              <Form.Control value={formatDateENGB(refundTicket?.refundDate)} />
            </Form.Group>
          </Form>
        </CommonModal>
      </React.Fragment>
    </React.Fragment>
  );
};

export default injectModels(["application"])(TicketList);
